<template>
  <div :id="mapId" width="100%" height="100%" style="border: 0" />
</template>
<script>
import "ol/ol.css";
import Feature from "ol/Feature";
import Map from "ol/Map";
import Point from "ol/geom/Point";
import VectorSource from "ol/source/Vector";
import View from "ol/View";
import { Icon, Style } from "ol/style";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { useGeographic } from "ol/proj";
import { OSM } from "ol/source";

export default {
  data() {
    return {
      randomNumber: 0,
      myMap: null,
      zoom: 18,
      vectorLayer: null
    };
  },
  props: ["value", "marker"],
  computed: {
    mapId: function() {
      return "map" + this.randomNumber;
    },
    getMarker: function() {
      if (this.marker) {
        return this.marker;
      }

      return "marker.png";
    }
  },
  watch: {
    value() {
      this.updateMarkerLocation(this.value.lng, this.value.lat);
    }
  },
  methods: {
    initMap() {
      useGeographic();

      const iconFeature = new Feature({
        geometry: new Point([this.value.lng, this.value.lat]),
        name: "Null Island",
        population: 4000,
        rainfall: 500
      });

      const iconStyle = new Style({
        image: new Icon({
          anchor: [0.5, 41],
          anchorXUnits: "fraction",
          anchorYUnits: "pixels",
          src: "/img/maps/" + this.getMarker
        })
      });

      iconFeature.setStyle(iconStyle);

      const vectorSource = new VectorSource({
        features: [iconFeature]
      });

      this.vectorLayer = new VectorLayer({
        source: vectorSource
      });

      this.myMap = new Map({
        target: this.mapId,
        layers: [
          new TileLayer({
            source: new OSM()
          }),
          this.vectorLayer
        ],
        view: new View({
          center: [this.value.lng, this.value.lat],
          zoom: this.zoom
        })
      });

      this.myMap.on("click", this.onMapClick);
    },
    onMapClick(e) {
      this.updateMarkerLocation(e.coordinate[0], e.coordinate[1]);

      let output = this.value;
      output.lat = e.coordinate[1];
      output.lng = e.coordinate[0];
      this.$emit("input", output);
    },
    updateMarkerLocation(lng, lat) {
      this.vectorLayer
        .getSource()
        .getFeatures()[0]
        .getGeometry()
        .setCoordinates([lng, lat]);

      let that = this;
      setTimeout(function() {
        that.myMap.getView().animate({
          center: [lng, lat],
          duration: 500
        });
      }, 10);
    }
  },
  created() {
    this.randomNumber = Math.random()
      .toString()
      .substr(2, 8);
  },
  mounted() {
    this.initMap();
  }
};
</script>
<style lang="scss">
div {
  .ol-control button {
    background-color: #2196f3;
  }
}
</style>
